export const breakpoints = {
  xs: "(max-width: 479px)",
  sm: "(max-width: 639px)",
  md: "(max-width: 767px)",
  lg: "(max-width: 1023px)",
  xl: "(max-width: 1279px)",
  "2xl": "(max-width: 1535px)",
}

export const minBreakpoints = {
  sm: "(min-width: 640px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1280px)",
  "2xl": "(min-width: 1536px)",
}
